function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { Alert, Stack, styled } from "@mui/material";
import { FormRadioGroup, RadioButton, Text } from "@vestwell-frontend/ui";
import { useFormikContext } from "formik";
var StyledAlert = styled(Alert)(function(props) {
    return {
        backgroundColor: props.theme.palette.grey800.main,
        borderColor: props.theme.palette.grey600.main,
        borderWidth: 1,
        maxWidth: '100%',
        width: props.theme.breakpoints.values.md,
        zIndex: 0
    };
});
var StyledFormRadioGroup = styled(FormRadioGroup)(function(props) {
    return {
        marginTop: 3,
        maxWidth: '100%',
        width: props.fullWidth ? props.theme.breakpoints.values.md : '100%'
    };
});
var StyledIcon = styled(InfoOutlined)(function(props) {
    return {
        marginTop: props.theme.spacing(0.5)
    };
});
export var FormWiredAtWorkToggleRadioGroup = function(_param) {
    var _param_name = _param.name, name = _param_name === void 0 ? 'wiredAtWork' : _param_name, props = _object_without_properties(_param, [
        "name"
    ]);
    var formikCtx = useFormikContext();
    return /*#__PURE__*/ _jsxs(Stack, {
        width: "100%",
        children: [
            /*#__PURE__*/ _jsxs(StyledFormRadioGroup, _object_spread_props(_object_spread({}, props), {
                label: "Does your company provide email addresses and access to computers to their employees?",
                name: name,
                variant: "standard",
                children: [
                    /*#__PURE__*/ _jsx(RadioButton, {
                        className: "mr-3",
                        label: "Yes",
                        value: true
                    }),
                    /*#__PURE__*/ _jsx(RadioButton, {
                        label: "No",
                        value: false
                    })
                ]
            })),
            formikCtx.values[name] === false && /*#__PURE__*/ _jsx(StyledAlert, {
                icon: /*#__PURE__*/ _jsx(StyledIcon, {
                    color: "grey100",
                    fontSize: "small"
                }),
                severity: "info",
                children: /*#__PURE__*/ _jsxs(Text, {
                    color: "grey100",
                    mb: 0,
                    variant: "g2",
                    children: [
                        "Our services are run largely off email and automation.",
                        /*#__PURE__*/ _jsx("br", {}),
                        "In situations where we are unable to directly communicate with employees in this manner, it will be the company's responsibility to do so."
                    ]
                })
            })
        ]
    });
};
FormWiredAtWorkToggleRadioGroup.displayName = 'FormWiredAtWorkToggleRadioGroup';

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1XaXJlZEF0V29ya1RvZ2dsZVJhZGlvR3JvdXAudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEluZm9PdXRsaW5lZCB9IGZyb20gJ0BtdWkvaWNvbnMtbWF0ZXJpYWwnO1xuaW1wb3J0IHsgQWxlcnQsIFN0YWNrLCBzdHlsZWQgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcbmltcG9ydCB7XG4gIEZvcm1SYWRpb0dyb3VwLFxuICBGb3JtUmFkaW9Hcm91cFByb3BzLFxuICBSYWRpb0J1dHRvbixcbiAgVGV4dFxufSBmcm9tICdAdmVzdHdlbGwtZnJvbnRlbmQvdWknO1xuXG5pbXBvcnQgeyB1c2VGb3JtaWtDb250ZXh0IH0gZnJvbSAnZm9ybWlrJztcbmltcG9ydCB7IEZDIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBTdHlsZWRBbGVydCA9IHN0eWxlZChBbGVydCkocHJvcHMgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiBwcm9wcy50aGVtZS5wYWxldHRlLmdyZXk4MDAubWFpbixcbiAgYm9yZGVyQ29sb3I6IHByb3BzLnRoZW1lLnBhbGV0dGUuZ3JleTYwMC5tYWluLFxuICBib3JkZXJXaWR0aDogMSxcbiAgbWF4V2lkdGg6ICcxMDAlJyxcbiAgd2lkdGg6IHByb3BzLnRoZW1lLmJyZWFrcG9pbnRzLnZhbHVlcy5tZCxcbiAgekluZGV4OiAwXG59KSk7XG5cbmNvbnN0IFN0eWxlZEZvcm1SYWRpb0dyb3VwID0gc3R5bGVkKEZvcm1SYWRpb0dyb3VwKShwcm9wcyA9PiAoe1xuICBtYXJnaW5Ub3A6IDMsXG4gIG1heFdpZHRoOiAnMTAwJScsXG4gIHdpZHRoOiBwcm9wcy5mdWxsV2lkdGggPyBwcm9wcy50aGVtZS5icmVha3BvaW50cy52YWx1ZXMubWQgOiAnMTAwJSdcbn0pKTtcblxuY29uc3QgU3R5bGVkSWNvbiA9IHN0eWxlZChJbmZvT3V0bGluZWQpKHByb3BzID0+ICh7XG4gIG1hcmdpblRvcDogcHJvcHMudGhlbWUuc3BhY2luZygwLjUpXG59KSk7XG5cbnR5cGUgRm9ybVdpcmVkQXRXb3JrVG9nZ2xlUmFkaW9Hcm91cFByb3BzID0gUGFydGlhbDxcbiAgT21pdDxGb3JtUmFkaW9Hcm91cFByb3BzLCAnY2hpbGRyZW4nIHwgJ2xhYmVsJz5cbj47XG5cbmV4cG9ydCBjb25zdCBGb3JtV2lyZWRBdFdvcmtUb2dnbGVSYWRpb0dyb3VwOiBGQzxcbiAgRm9ybVdpcmVkQXRXb3JrVG9nZ2xlUmFkaW9Hcm91cFByb3BzXG4+ID0gKHsgbmFtZSA9ICd3aXJlZEF0V29yaycsIC4uLnByb3BzIH0pID0+IHtcbiAgY29uc3QgZm9ybWlrQ3R4ID0gdXNlRm9ybWlrQ29udGV4dCgpO1xuXG4gIHJldHVybiAoXG4gICAgPFN0YWNrIHdpZHRoPScxMDAlJz5cbiAgICAgIDxTdHlsZWRGb3JtUmFkaW9Hcm91cFxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIGxhYmVsPSdEb2VzIHlvdXIgY29tcGFueSBwcm92aWRlIGVtYWlsIGFkZHJlc3NlcyBhbmQgYWNjZXNzIHRvIGNvbXB1dGVycyB0byB0aGVpciBlbXBsb3llZXM/J1xuICAgICAgICBuYW1lPXtuYW1lfVxuICAgICAgICB2YXJpYW50PSdzdGFuZGFyZCc+XG4gICAgICAgIDxSYWRpb0J1dHRvbiBjbGFzc05hbWU9J21yLTMnIGxhYmVsPSdZZXMnIHZhbHVlPXt0cnVlfSAvPlxuICAgICAgICA8UmFkaW9CdXR0b24gbGFiZWw9J05vJyB2YWx1ZT17ZmFsc2V9IC8+XG4gICAgICA8L1N0eWxlZEZvcm1SYWRpb0dyb3VwPlxuICAgICAge2Zvcm1pa0N0eC52YWx1ZXNbbmFtZV0gPT09IGZhbHNlICYmIChcbiAgICAgICAgPFN0eWxlZEFsZXJ0XG4gICAgICAgICAgaWNvbj17PFN0eWxlZEljb24gY29sb3I9J2dyZXkxMDAnIGZvbnRTaXplPSdzbWFsbCcgLz59XG4gICAgICAgICAgc2V2ZXJpdHk9J2luZm8nPlxuICAgICAgICAgIDxUZXh0IGNvbG9yPSdncmV5MTAwJyBtYj17MH0gdmFyaWFudD0nZzInPlxuICAgICAgICAgICAgT3VyIHNlcnZpY2VzIGFyZSBydW4gbGFyZ2VseSBvZmYgZW1haWwgYW5kIGF1dG9tYXRpb24uXG4gICAgICAgICAgICA8YnIgLz5cbiAgICAgICAgICAgIEluIHNpdHVhdGlvbnMgd2hlcmUgd2UgYXJlIHVuYWJsZSB0byBkaXJlY3RseSBjb21tdW5pY2F0ZSB3aXRoXG4gICAgICAgICAgICBlbXBsb3llZXMgaW4gdGhpcyBtYW5uZXIsIGl0IHdpbGwgYmUgdGhlIGNvbXBhbnkmYXBvcztzXG4gICAgICAgICAgICByZXNwb25zaWJpbGl0eSB0byBkbyBzby5cbiAgICAgICAgICA8L1RleHQ+XG4gICAgICAgIDwvU3R5bGVkQWxlcnQ+XG4gICAgICApfVxuICAgIDwvU3RhY2s+XG4gICk7XG59O1xuXG5Gb3JtV2lyZWRBdFdvcmtUb2dnbGVSYWRpb0dyb3VwLmRpc3BsYXlOYW1lID0gJ0Zvcm1XaXJlZEF0V29ya1RvZ2dsZVJhZGlvR3JvdXAnO1xuIl0sIm5hbWVzIjpbIkluZm9PdXRsaW5lZCIsIkFsZXJ0IiwiU3RhY2siLCJzdHlsZWQiLCJGb3JtUmFkaW9Hcm91cCIsIlJhZGlvQnV0dG9uIiwiVGV4dCIsInVzZUZvcm1pa0NvbnRleHQiLCJTdHlsZWRBbGVydCIsInByb3BzIiwiYmFja2dyb3VuZENvbG9yIiwidGhlbWUiLCJwYWxldHRlIiwiZ3JleTgwMCIsIm1haW4iLCJib3JkZXJDb2xvciIsImdyZXk2MDAiLCJib3JkZXJXaWR0aCIsIm1heFdpZHRoIiwid2lkdGgiLCJicmVha3BvaW50cyIsInZhbHVlcyIsIm1kIiwiekluZGV4IiwiU3R5bGVkRm9ybVJhZGlvR3JvdXAiLCJtYXJnaW5Ub3AiLCJmdWxsV2lkdGgiLCJTdHlsZWRJY29uIiwic3BhY2luZyIsIkZvcm1XaXJlZEF0V29ya1RvZ2dsZVJhZGlvR3JvdXAiLCJuYW1lIiwiZm9ybWlrQ3R4IiwibGFiZWwiLCJ2YXJpYW50IiwiY2xhc3NOYW1lIiwidmFsdWUiLCJpY29uIiwiY29sb3IiLCJmb250U2l6ZSIsInNldmVyaXR5IiwibWIiLCJiciIsImRpc3BsYXlOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLFNBQVNBLFlBQVksUUFBUSxzQkFBc0I7QUFDbkQsU0FBU0MsS0FBSyxFQUFFQyxLQUFLLEVBQUVDLE1BQU0sUUFBUSxnQkFBZ0I7QUFDckQsU0FDRUMsY0FBYyxFQUVkQyxXQUFXLEVBQ1hDLElBQUksUUFDQyx3QkFBd0I7QUFFL0IsU0FBU0MsZ0JBQWdCLFFBQVEsU0FBUztBQUcxQyxJQUFNQyxjQUFjTCxPQUFPRixPQUFPUSxTQUFBQTtXQUFVO1FBQzFDQyxpQkFBaUJELE1BQU1FLEtBQUssQ0FBQ0MsT0FBTyxDQUFDQyxPQUFPLENBQUNDLElBQUk7UUFDakRDLGFBQWFOLE1BQU1FLEtBQUssQ0FBQ0MsT0FBTyxDQUFDSSxPQUFPLENBQUNGLElBQUk7UUFDN0NHLGFBQWE7UUFDYkMsVUFBVTtRQUNWQyxPQUFPVixNQUFNRSxLQUFLLENBQUNTLFdBQVcsQ0FBQ0MsTUFBTSxDQUFDQyxFQUFFO1FBQ3hDQyxRQUFRO0lBQ1Y7O0FBRUEsSUFBTUMsdUJBQXVCckIsT0FBT0MsZ0JBQWdCSyxTQUFBQTtXQUFVO1FBQzVEZ0IsV0FBVztRQUNYUCxVQUFVO1FBQ1ZDLE9BQU9WLE1BQU1pQixTQUFTLEdBQUdqQixNQUFNRSxLQUFLLENBQUNTLFdBQVcsQ0FBQ0MsTUFBTSxDQUFDQyxFQUFFLEdBQUc7SUFDL0Q7O0FBRUEsSUFBTUssYUFBYXhCLE9BQU9ILGNBQWNTLFNBQUFBO1dBQVU7UUFDaERnQixXQUFXaEIsTUFBTUUsS0FBSyxDQUFDaUIsT0FBTyxDQUFDO0lBQ2pDOztBQU1BLE9BQU8sSUFBTUMsa0NBRVQ7NkJBQUdDLE1BQUFBLGdDQUFPLDZCQUFrQnJCO1FBQXpCcUI7O0lBQ0wsSUFBTUMsWUFBWXhCO0lBRWxCLHFCQUNFLE1BQUNMO1FBQU1pQixPQUFNOzswQkFDWCxNQUFDSyw4REFDS2Y7Z0JBQ0p1QixPQUFNO2dCQUNORixNQUFNQTtnQkFDTkcsU0FBUTs7a0NBQ1IsS0FBQzVCO3dCQUFZNkIsV0FBVTt3QkFBT0YsT0FBTTt3QkFBTUcsT0FBTzs7a0NBQ2pELEtBQUM5Qjt3QkFBWTJCLE9BQU07d0JBQUtHLE9BQU87Ozs7WUFFaENKLFVBQVVWLE1BQU0sQ0FBQ1MsS0FBSyxLQUFLLHVCQUMxQixLQUFDdEI7Z0JBQ0M0QixvQkFBTSxLQUFDVDtvQkFBV1UsT0FBTTtvQkFBVUMsVUFBUzs7Z0JBQzNDQyxVQUFTOzBCQUNULGNBQUEsTUFBQ2pDO29CQUFLK0IsT0FBTTtvQkFBVUcsSUFBSTtvQkFBR1AsU0FBUTs7d0JBQUs7c0NBRXhDLEtBQUNRO3dCQUFLOzs7Ozs7QUFTbEIsRUFBRTtBQUVGWixnQ0FBZ0NhLFdBQVcsR0FBRyJ9